import { useState } from "react";
import { useParams } from "react-router-dom";
import TagesgruppenJahrTabelle from "../TagesgruppenJahr/TagesgruppenJahrTabelle";
import EinwohnerTabelle from "../Einwohner/EinwohnerTabelle";

var MonitorApi = require('monitor-api');

export default function UniqueJahr ({myApiClient}) {
    const { uniqueYear } = useParams();
    let gruppeZuJahrInstance = new MonitorApi.TagesgruppeZuJahrApi(myApiClient);
    let einwohnerInstance = new MonitorApi.EinwohnerApi(myApiClient);
    let zweckverbandInstance = new MonitorApi.ZweckverbandApi(myApiClient);
    

    const [showGruppen, setShowGruppen] = useState(false);
    const [showEinwohner, setShowEinwohner] = useState(false);

    return (
        <div>
            <h2>Zahlen des Jahres {uniqueYear}</h2>

            <section>
                <div className="header-table">
                    <h3>Daten der Tagesgruppen</h3>
                    <button onClick={() => setShowGruppen(!showGruppen)}>&#8711;</button>
                    {/* &#8897;  &#8711;*/}
                </div>
                {showGruppen &&
                <div className="whole-table"><TagesgruppenJahrTabelle gruppeZuJahrInstance={gruppeZuJahrInstance}/></div>}
            </section>

            <section>
                <div className="header-table">
                    <h3>Einwohner pro Zweckverband</h3>
                    <button onClick={() => setShowEinwohner(!showEinwohner)}>&#8711;</button>
                </div>
                <div className="whole-table einwohner">
                    {showEinwohner && 
                    <EinwohnerTabelle einwohnerInstance={einwohnerInstance} zweckverbandInstance={zweckverbandInstance} />}
                </div>
            </section>
        </div>
    )
}